import { Button, Divider, Table, Tag, message } from "antd";
import { useEffect, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
///redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";

import { Modal, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

import { useNavigate } from "react-router-dom";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const OPGNumberingMainPage = (props) => {
  let navigate = useNavigate();
  const [_paging, setPaging] = useState({ pageNumber: 1, pageSize: 10 });

  const Columns = [
    {
      title: "Patien Id",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.patientId}</div>;
      },
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.type}</div>;
      },
    },
    {
      title: "Image",
      dataIndex: "Image",
      key: "Image",
      render: (obj, item, index) => {
        let imageObj = item;
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        if (item?.hasPeriapicalLesionAnalysis) {
          return (
            <Tag
              color="#87d068"
              style={{ cursor: "pointer" }}
              onClick={() => _onClickEdit(item)}
            >
              Edit Analysis
            </Tag>
          );
        }
        return (
          <Button onClick={() => _onClickAnalyses(item.id)}>Analyses</Button>
        );
      },
    },
    {
      title: "Segment",
      dataIndex: "segment",
      key: "segment",
      render: (obj, item) => {
        if (item?.cbctSegmentDone) {
          return (
            <Tag
              color="#108ee9"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`./segment/${item.id}`)}
            >
              Edit Segment
            </Tag>
          );
        }
        return (
          <Button onClick={() => navigate(`./segment/${item.id}`)}>
            Segment
          </Button>
        );
      },
    },
    {
      title: "مشخص کردن اندازه",
      dataIndex: "ruler",
      key: "ruler",
      render: (obj, item) => {
        if (item?.hasCbctRuler) {
          return (
            <Tag
              color="#87d068"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`./ruler/${item.id}`)}
            >
              Edit Ruler
            </Tag>
          );
        }
        return (
          <Button onClick={() => navigate(`./ruler/${item.id}`)}>Ruler</Button>
        );
      },
    },
  ];

  const [open, setOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning("Please select at least one image.");
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    try {
      setLoading(true);

      await axios.post(Url.baseURL[0] + Url.cbctaiuploadimages, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("@token")}`, // JWT
        },
      });

      message.success("Images uploaded successfully!");
      setFileList([]);
      setOpen(false);
    } catch (error) {
      console.error(error);
      message.error("Upload failed!");
    } finally {
      setLoading(false);
    }
  };
  const _onClickEdit = (item) => {
    let idEdit = 0;
    idEdit = item?.periapicalLesionAnalysis[0]?.id;
    navigate(`./analyses/${item.id}/${idEdit}`);
    console.log(item);
  };
  const _getListPatient = async (paging) => {
    let _paging = paging;

    if (paging == null) {
      _paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    let url = Url.GetListImageForCbctAi;

    let res = await props.actions.CallCoreServicesActionWithToken(url, _paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _getListAnalysis = async () => {
    let url = Url.lateral_GetListAnalyses;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  useEffect(() => {
    // _getListAnalysis();

    let paging = JSON.parse(localStorage.getItem("@cbctai"));
    if (paging == null) {
      paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    setPaging(paging);
    _getListPatient(paging);
  }, []);

  const _onClickAnalyses = (id) => {
    navigate(`./analyses/${id}`);
  };
  const _onClickEditAnalyses = (item) => {
    navigate(`/lateralchephalo/analyses/${item.patientId}/${item.id}`);
  };
  const _onChangePageSize = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@cbctai",
      JSON.stringify({
        pageNumber,
        pageSize,
      }),
    );
    setPaging({ pageNumber, pageSize });
    _getListPatient({
      pageNumber,
      pageSize,
    });
  };

  const returnSideBar = () => {
    return (
      <div dir="ltr" style={{ height: "100%" }}>
        <div
          className="btn-gradient margin-top"
          onClick={() => navigate("./segment")}
        >
          Segment
        </div>
        <div
          className="btn-gradient margin-top"
          onClick={() => navigate("./youranalyses")}
        >
          Your Analyses
        </div>
        <Button type="primary" onClick={() => setOpen(true)}>
          Upload CBCT Maxilla Images
        </Button>

        <Modal
          title="Upload CBCT Maxilla Images"
          open={open}
          onCancel={() => setOpen(false)}
          onOk={handleUpload}
          confirmLoading={loading}
          okText="Upload"
        >
          <Upload
            multiple
            accept="image/*"
            beforeUpload={() => false} // prevent auto upload
            fileList={fileList}
            onChange={({ fileList }) => setFileList(fileList)}
          >
            <Button icon={<UploadOutlined />}>Select Images</Button>
          </Upload>
        </Modal>
      </div>
    );
  };
  return (
    <div dir="ltr" className="flex-row">
      <div>{returnSideBar()}</div>
      <div className="flex-1">
        <Table
          style={{ width: "100%" }}
          columns={Columns}
          dataSource={
            props.coreData[Url.GetListImageForCbctAi]?.[Url.action]?.data
              ?.patients
          }
          loading={
            props.coreData[Url.GetListImageForCbctAi]?.[Url.action]?.isFetching
          }
          pagination={{
            current: _paging.pageNumber,
            pageSize: _paging.pageSize,
            total:
              props.coreData[Url.GetListImageForCbctAi]?.[Url.action]?.data
                ?.totalCount,
            onChange: _onChangePageSize,
          }}
          rowKey={(o) => o.id}
        />
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices },
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OPGNumberingMainPage);
